<template>
  <PageHeaderLayout :isBack="true">
    <div class="main-page-content">
      <el-row class="table-search">
        <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input
              v-model="searchCondition.name"
              placeholder="请输入姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              v-model="searchCondition.mobile"
              placeholder="请输入联系方式"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchButton">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <ApeTable
        ref="apeTable"
        :data="enrollmentList"
        :columns="columns"
        :loading="loadingStaus"
        :pagingData="pagingData"
        @switchPaging="switchPaging"
        highlight-current-row
      >
        <el-table-column
          slot="second-column"
          width="64"
          label="序号"
        >
          <template slot-scope="scope">
            <span>{{ offset + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
      </ApeTable>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'

export default {
  components: {
    PageHeaderLayout,
    ApeTable
  },
  data() {
    return {
      searchCondition: {
        name: '',
        mobile: ''
      },
      loadingStaus: true,
      columns: [
        { title: '姓名', value: 'name' },
        { title: '联系方式', value: 'mobile' },
        { title: '报名时间', value: 'created_at', width: 180 }
      ],
      enrollmentList: [],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      offset: 0
    }
  },
  computed: {
    trainingId() {
      return this.$route.params.id
    }
  },
  watch: {
    trainingId: {
      handler() {
        this.initList()
      },
      immediate: true
    }
  },
  methods: {
    searchButton() {
      this.initList('search')
    },
    switchPaging() {
      this.initList()
    },
    async initList(type) {
      if (!this.trainingId) return
      this.loadingStaus = true
      const pagingInfo = this.$refs['apeTable'] && this.$refs['apeTable'].getPagingInfo(type) || {
        current_page: 1,
        page_size: 10
      }
      if (type === 'search') {
        pagingInfo.current_page = 1
      }
      const params = {
        training_id: this.trainingId,
        ...this.searchCondition,
        ...pagingInfo
      }
      try {
        const res = await this.$api.getEnrollmentList(params)
        const list = res.list || res.data || []
        const pages = res.pages || { total: 0, offset: 0 }
        this.enrollmentList = list
        this.pagingData.total = pages.total || 0
        this.offset = pages.offset || 0
      } catch (e) {
        this.enrollmentList = []
        this.$message.error(e.message || '获取报名列表失败')
      }
      this.loadingStaus = false
    }
  }
}
</script>

<style lang="scss" scoped>
.table-search {
  margin-bottom: 16px;
}
</style>
